import { Theme } from "@mui/material/styles";

export interface TaskColorMap {
  [key: string]: string;
}

// Function to generate task color map using theme colors
export const getTaskColorMap = (theme: Theme): TaskColorMap => {
  return {
    A: theme.palette.blue?.main ,
    B: theme.palette.orange?.main ,
    C: theme.palette.skyBlue?.main ,
    D: theme.palette.purple?.main ,
    E: theme.palette.red?.main,
    F: theme.palette.purple?.main,
    G: theme.palette.mintGreen?.main,
    H: theme.palette.purple?.main,
    I: theme.palette.brown?.main,
    J: theme.palette.customColors?.greyDarkborder,
    K: theme.palette.blue?.main,
    L: theme.palette.blushPink?.main,
    M: theme.palette.orange?.main,
    N: theme.palette.blue?.main,
    O: theme.palette.skyBlue?.main,
    P: theme.palette.orange?.main,
    Q: theme.palette.goldenYellow?.main,
    R: theme.palette.blue?.main,
    S: theme.palette.red?.main,
    T: theme.palette.purple?.main,
    U: theme.palette.mintGreen?.main,
    V: theme.palette.green?.main,
    W: theme.palette.skyBlue?.main,
    X: theme.palette.orange?.main,
    Y: theme.palette.customColors?.greyDarkborder,
    Z: theme.palette.goldenYellow?.main,
  };
};
